export const ACTIONS_LOAD = 'ACTIONS_LOAD';
export const ACTIONS_LOAD_SUCCESS = 'ACTIONS_LOAD_SUCCESS';
export const ACTIONS_LOAD_ERROR = 'ACTIONS_LOAD_ERROR';

export const ACTIONS_ADD = 'ACTIONS_ADD';
export const ACTIONS_ADD_SUCCESS = 'ACTIONS_ADD_SUCCESS';
export const ACTIONS_ADD_ERROR = 'ACTIONS_ADD_ERROR';
export const ACTIONS_UPDATE = 'ACTIONS_UPDATE';
export const ACTIONS_UPDATE_SUCCESS = 'ACTIONS_UPDATE_SUCCESS';
export const ACTIONS_UPDATE_ERROR = 'ACTIONS_UPDATE_ERROR';
export const ACTIONS_DELETE = 'ACTIONS_DELETE';
export const ACTIONS_DELETE_SUCCESS = 'ACTIONS_DELETE_SUCCESS';
export const ACTIONS_DELETE_ERROR = 'ACTIONS_DELETE_ERROR';

export const ACTION_ADD = 'ACTION_ADD';
export const ACTION_ADD_SUCCESS = 'ACTION_ADD_SUCCESS';
export const ACTION_ADD_ERROR = 'ACTION_ADD_ERROR';
export const ACTION_UPDATE = 'ACTION_UPDATE';
export const ACTION_UPDATE_SUCCESS = 'ACTION_UPDATE_SUCCESS';
export const ACTION_UPDATE_ERROR = 'ACTION_UPDATE_ERROR';
export const ACTION_DELETE = 'ACTION_DELETE';
export const ACTION_DELETE_SUCCESS = 'ACTION_DELETE_SUCCESS';
export const ACTION_DELETE_ERROR = 'ACTIONS_DELETE_ERROR';
